import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/tokens.css";
import "./styles/system.css";
import "./styles/utilities.css";
import App from "./App";
import "./App.css";
import { installProxyAuth } from "./lib/proxyAuth";

installProxyAuth();


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
